import { useContext } from 'react';

import { ThemeContext, type ThemeContextValue } from '@/app/providers/themeContext';

/**
 * Access the current theme.
 *
 * Throws rather than returning a default when used outside the provider: a
 * silent fallback would render the wrong palette and be hard to trace back.
 */
export function useTheme(): ThemeContextValue {
  const context = useContext(ThemeContext);
  if (context === null) {
    throw new Error('useTheme must be used inside a <ThemeProvider>.');
  }
  return context;
}
